import { RESET_UPLOAD_MODEL } from '../actionTypes';
import { productDatasheetsActions } from '../reducer';

export default () => productDatasheetsActions[RESET_UPLOAD_MODEL](null);
